import React, { Component } from 'react'
import { conditionalWidth, translate } from '../../utils/useful'

export default class EmailToolbar extends Component {
    render() {
        return (
            <div>
                <div className='w-100 flexc'>
                    <button className="flexc mr-1 px-3 email-tool br-20 py-1" >
                        <img src="/assets/icons/email/reply-white.svg" alt="" className='mrd-1' style={{ userSelect: 'none', }} width={20} />
                        <p className='font-size-12' style={{ whiteSpace: "nowrap", userSelect: 'none' }}>{translate('mail.Reply')}</p>
                    </button>

                    <button className="flexc px-3 mx-1 email-tool br-20 py-1">
                        <img src="/assets/icons/email/replyall-white.svg" alt="" className='mrd-1' style={{ userSelect: 'none' }} width={20} />
                        <p className='font-size-12' style={{ whiteSpace: "nowrap", userSelect: 'none' }}>{translate('mail.Reply All')}</p>
                    </button>

                    <button className="flexc px-3 mx-1 email-tool br-20 py-1">
                        <img src="/assets/icons/email/forward-white.svg" alt="" className='mrd-1' style={{ userSelect: 'none' }} width={20} />
                        <p className='font-size-12' style={{ whiteSpace: "nowrap", userSelect: 'none' }}>{translate('mail.Forward')}</p>
                    </button>
                </div>
            </div>
        )
    }
}
